// Scroll
export const SET_SCROLL = 'DREIPOL_VUE_UI__SCROLL__SET_SCROLL';
export const DISABLE_SCROLL = 'DREIPOL_VUE_UI__SCROLL__DISABLE_SCROLL';

// Overlay
export const MOUNT_OVERLAY = 'DREIPOL_VUE_UI__OVERLAY__MOUNT_OVERLAY';
export const UNMOUNT_OVERLAY = 'DREIPOL_VUE_UI__OVERLAY__UNMOUNT_OVERLAY';
export const OPEN_OVERLAY = 'DREIPOL_VUE_UI__OVERLAY__OPEN_OVERLAY';
export const UPDATE_OVERLAY = 'DREIPOL_VUE_UI__SCROLL__UPDATE_OVERLAY';
export const PREPARE_CLOSE_OVERLAY = 'DREIPOL_VUE_UI__OVERLAY__PREPARE_CLOSE_OVERLAY';
export const CLOSE_OVERLAY = 'DREIPOL_VUE_UI__OVERLAY__CLOSE_OVERLAY';
